import * as React from 'react';
import { CmdError } from '@commander-services/gui-components';

export type TInputType = 'color' | 'text' | 'number' | 'password' | 'hidden' | 'email';

interface IInputProps {
  id: string;
  label: string;
  name: string;
  type: TInputType;
  placeholder?: string;
  readonly?: boolean;
  className?: string;
  error?: string;
  onChangeCallback: (value: string) => void;
}

export default function LoginInput(props: IInputProps) {
  let errBorder = '';
  if (props.error) {
    errBorder = 'err-border';
  }

  const handleOnChange = (event) => {
    props.onChangeCallback(event.target.value);
  };

  return (
    <div className={`m-0 mb-2 text-input-component ${errBorder ? 'has-error' : ''}`}>
      <div className="row">
        <label htmlFor={props.id} className="col-12 font-weight-bold mb-1">
          {props.label}
        </label>
        <div className="col-12">
          <input
            data-cy={`form-input-${props.name}`}
            type={props.type}
            placeholder={props.placeholder || ''}
            name={props.name}
            id={props.id}
            readOnly={props.readonly || false}
            className={`${props.className} form-control ${errBorder}`}
            onChange={handleOnChange}
          />
          {props.error && (
            <div>
              <div className="form-group-error">
                <CmdError message={props.error} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
